import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    FormsModule,
    ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FooterComponent } from 'app/components/footer/footer.component';
import { HeaderComponent } from 'app/components/header/header.component';
import { ChatbotService } from '../chatbot.service';
import { ToastrService } from 'ngx-toastr';
@Component({
    selector: 'app-chatbot-survey-form',
    templateUrl: './chatbot-survey-form.component.html',
    styleUrls: ['./chatbot-survey-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        FormsModule,
        CommonModule,
        MatIconModule,
        FooterComponent,
        HeaderComponent,
        MatButtonModule,
        TranslateModule,
        ReactiveFormsModule,
    ],
    standalone: true,
})
export class ChatbotSurveyFormComponent implements OnInit {
    rating: number = 0;
    starCount: number = 5;
    overal_exp: number = 0;
    ease_of_use: number = 0;
    informative: number = 0;

    SuccessMsg: any;
    closeTostr: any;
    noratingmsg: any;
    languageSelected: any;
    feedbackForm: FormGroup;
    clickedOutside: boolean = false;
    submittedSuccessfully: boolean = false;

    starRatingArr = [];
    circleRatingArr = [];

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private route: ActivatedRoute,
        private translate: TranslateService,
        private chatbotService: ChatbotService,
        private toastr: ToastrService,
    ) {
        this.route.queryParams.subscribe((params) => {
            this.languageSelected = params.lang;
        });
    }

    ngOnInit() {
        this.feedbackForm = this.fb.group({
            feedback: [''],
        });

        for (let index = 0; index < this.starCount; index++) {
            this.starRatingArr.push(index);
            this.circleRatingArr.push(index);
        }

        this.translate.get('COMMON.CLOSE').subscribe((data: any) => {
            this.closeTostr = data;
        });

        this.translate
            .get('CHATBOT_SURVEY_PAGE.REQUIRED_RATING')
            .subscribe((data: any) => {
                this.noratingmsg = data;
            });

        this.translate
            .get('CHATBOT_SURVEY_PAGE.SUCCESSFUL_RATING_SENT')
            .subscribe((data: any) => {
                this.SuccessMsg = data;
            });
    }

    onClickRating(rating: number) {
        this.rating = rating;
    }

    onSubmit() {
        if (
            this.rating > 0 &&
            this.overal_exp > 0 &&
            this.ease_of_use > 0 &&
            this.informative > 0
        ) {
            let data = {
                rating1: this.rating,
                rating2: this.overal_exp,
                rating3: this.ease_of_use,
                rating4: this.informative,
                feedback: this.feedbackForm.value.feedback,
            };

            let authenticated = localStorage.getItem('isAuthenticated');
            this.chatbotService
                .submitChatbotRating(authenticated, data)
                .subscribe({
                    next: (data) => {
                        this.submittedSuccessfully = true;
                        setTimeout(() => {
                            this.router.navigate(['home']);
                        }, 1500);
                    },
                    error: (error) => {
                        this.toastr.error('error');
                    },
                });
        } else {
            this.submittedSuccessfully = false;
            this.toastr.error(this.noratingmsg);
        }
    }

    onCancel() {
        this.feedbackForm.reset();
        this.rating = 0;
        this.overal_exp = 0;
        this.ease_of_use = 0;
        this.informative = 0;
    }

    showIcon(index: number) {
        if (this.rating >= index + 1) {
            return 'star';
        } else {
            return 'star_border';
        }
    }

    changeMenuCondition(event: any) {
        this.clickedOutside = false;
    }

    closeMegaMenuCondition() {
        this.clickedOutside = !this.clickedOutside;
    }

    switchLanguageHandler(data: any) {
        this.languageSelected = data;
    }
}
